import type { SVGProps } from 'react';

const SvgCrop169 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M21 7H3v10h18zm-2 8H5V9h14z" />
  </svg>
);
export default SvgCrop169;
